import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  useFindOneRmaQuery,
  useSendRmaEmailMutation,
} from "../../api/api-hooks";
import ToggleSwitch from "../../components/ToggleSwitch";
import { useHardwareTypeMap } from "../../hooks/useHardwareTypeMap";
import { buildCompletedEmail, buildInitialEmail } from "./RmaUtils";

interface Props {
  dialogOpen: boolean;
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  clickedRma: string | number;
}

const LptRmaEmailsDialog = ({
  dialogOpen,
  setDialogOpen,
  clickedRma,
}: Props) => {
  const [message, setMessage] = useState<string>("");
  const [isInitial, setIsInitial] = useState<boolean>(true);
  const [sendMessage] = useSendRmaEmailMutation();
  const { data: selectedRma } = useFindOneRmaQuery({ id: Number(clickedRma) });
  const typeMap = useHardwareTypeMap();
  useEffect(() => {
    if (selectedRma === undefined || typeMap === undefined) return;
    const typeId = selectedRma.hardware.hardwareTypeId;
    const typeName = typeMap.get(typeId);
    if (isInitial) {
      const message = buildInitialEmail(
        selectedRma.nameId,
        selectedRma.contactName ? selectedRma.contactName : "",
        typeName || "hardware",
        selectedRma.hardware.serial,
        selectedRma.issue ? selectedRma.issue : "",
        selectedRma.notes ? selectedRma.notes : ""
      );
      setMessage(message);
    } else {
      const message = buildCompletedEmail(
        typeName || "hardware",
        selectedRma.hardware.serial,
        selectedRma.contactName ? selectedRma.contactName : ""
      );
      setMessage(message);
    }
  }, [clickedRma, selectedRma, isInitial, typeMap]);
  if (selectedRma === undefined) return null;
  const closeDialog = () => {
    setDialogOpen(false);
    setIsInitial(true);
  };
  const handleChange = (event: any) => {
    const { value } = event.target;
    setMessage(value);
  };
  const handleSend = () => {
    sendMessage({
      sendEmailDto: {
        emailText: message,
        emailAddress: selectedRma.email ? selectedRma.email : "",
        rmaNameId: selectedRma.nameId,
      },
    });
    setDialogOpen(false);
  };
  const toggleToInitial = () => {
    setIsInitial(true);
  };
  const toggleToCompleted = () => {
    setIsInitial(false);
  };
  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={dialogOpen}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Send Email</DialogTitle>
      <DialogContent>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <TextField
              multiline
              fullWidth
              rows={25}
              value={message}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>
          <Grid item container spacing={1} alignItems="center">
            <Grid item>
              <ToggleSwitch
                options={["Initial", "Completed"]}
                onClicks={[toggleToInitial, toggleToCompleted]}
                startingOption="Initial"
              />
            </Grid>
            <Grid item>
              <Typography>Email will be sent to {selectedRma.email}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSend}>Send</Button>
        <Button onClick={closeDialog}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default LptRmaEmailsDialog;
